<template>
  <div>
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="cohortData === undefined">
      <h4 class="alert-heading">Error fetching cohort data</h4>
      <div class="alert-body">
        No cohort found with this cohort id. Check
        <b-link class="alert-link" :to="{ name: 'apps-placement-cohort-list' }"> Cohort List </b-link>
        for other cohorts.
      </div>
    </b-alert>

    <template v-if="cohortData">
      <!-- First Row -->
      <b-row>
        <b-col cols="12" xl="3" lg="3" md="12">
          <cohort-view-cohort-info-card :cohort-data="cohortData" />
        </b-col>
        <b-col cols="12" md="12" xl="9" lg="9">
          <b-card no-body class="mb-0">
            <cohort-view-cohort-permissions-card
              v-on:refresh="loadCohortSummary"
              :cohort-data="cohortData"
            ></cohort-view-cohort-permissions-card>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="false">
        <b-col cols="12" lg="6"> </b-col>
        <b-col cols="12" lg="6"> </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import store from '@/store';
import router from '@/router';
import { ref, onUnmounted } from '@vue/composition-api';
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BTable,
  BFormInput,
  BButton,
  BCard,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BDropdownDivider,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue';
import placementStoreModule from '../placementStoreModule';
import CohortViewCohortInfoCard from './CohortViewUserInfoCard';
import CohortViewCohortPermissionsCard from './CohortViewUserPermissionsCard.vue';
import useCohortProfilesList from './useCohortProfilesList';

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BTable,

    BCard,
    BFormInput,
    BButton,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BDropdownDivider,

    vSelect,

    // Local Components
    CohortViewCohortInfoCard,
    CohortViewCohortPermissionsCard,

    InvoiceList,
  },
  methods: {
    loadCohortSummary(includeLight = false) {
      let isRichFulfilled = false;

     if (includeLight) {
       this.$store
         .dispatch('app-placement/fetchCohort', {
           id: router.currentRoute.params.id,
         })
         .then((response) => {
           const data = response.data;
           console.log(`cohort`, data);

           data.profiles = [];

           if (!isRichFulfilled) this.cohortData = data;
         })
         .catch((error) => {
           if (error.response.status === 404) {
             this.cohortData = undefined;
           }
         });
     }

      this.$store
        .dispatch('app-placement/fetchCohortSummary', {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          response.data.profiles = response.data.profiles
            // .sort((a, b) => b.createdAt - a.createdAt)
            .sort((a, b) => b.student.studentId - a.student.studentId)
            .sort((a, b) => b.certificates.length - a.certificates.length)
            .sort((a, b) => b.priority - a.priority)
            .sort((a, b) => b.recommended - a.recommended);

          this.cohortData = response.data;
          isRichFulfilled = true;
          console.log(`cohort`, response.data);
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.cohortData = undefined;
          }
        });
    },
  },
  mounted() {
    this.loadCohortSummary(true);
  },
  setup() {
    const cohortData = ref(null);

    const COHORT_APP_STORE_MODULE_NAME = 'app-placement';

    // Register module
    if (!store.hasModule(COHORT_APP_STORE_MODULE_NAME))
      store.registerModule(COHORT_APP_STORE_MODULE_NAME, placementStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COHORT_APP_STORE_MODULE_NAME)) store.unregisterModule(COHORT_APP_STORE_MODULE_NAME);
    });

    const {
      fetchSessions,
      tableColumns,
      perPage,
      currentPage,
      totalSessions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSessionListTable,
      refetchData,

      statusOptions,

      // UI
      resolveSessionVisibilityVariant,
      resolveSessionStatusVariant,

      // Extra Filters
      visibilityFilter,
      statusFilter,
    } = useCohortProfilesList(cohortData);

    return {
      cohortData,

      fetchSessions,
      tableColumns,
      perPage,
      currentPage,
      totalSessions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSessionListTable,
      refetchData,

      statusOptions,

      // UI
      resolveSessionVisibilityVariant,
      resolveSessionStatusVariant,

      // Extra Filters
      visibilityFilter,
      statusFilter,
    };
  },
};
</script>

<style></style>
